<template>
  <el-row>
    <el-row class="sj-container">
      <el-table :highlight-current-row="true"
                :data="table"
                :show-header="false"
                border>
        <el-table-column width="150"
                         prop="label">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
          <template slot-scope="scope">
             <span v-if="detailData[scope.row.key] || detailData[scope.row.key] === 0">
              <span v-if="detailData[scope.row.key].constructor === String && !imgFields.includes(scope.row.key)">{{detailData[scope.row.key]}}</span>
              <span v-if="imgFields.includes(scope.row.key)">
                <el-image :src="detailData[scope.row.key]"
                          style="width: 200px;"
                          :preview-src-list="[detailData[scope.row.key]]">
                </el-image>
              </span>
               <span v-if="ifKey(scope, 'idnumverified')">
                <span v-for="value in options[scope.row.key]">
                  <span v-if="value.value === detailData[scope.row.key]" :style="{color: value.color}">{{value.label}}</span>
                </span>
              </span>
              <span v-if="ifKey(scope, 'money_message')">
                <div style="color: rgb(88,157,248);">已提现赏金: {{detailData.totalwithdraw}}</div>
                <div style="color: rgb(88,157,248);">提现中赏金: {{detailData.frozenbalance}}</div>
                <div style="color: rgb(88,157,248);">赏金金额: {{detailData.balance}}</div>
              </span>
              <span v-if="ifKey(scope, 'point_message')">
                <div style="color: rgb(88,157,248);">零豆余额: {{detailData.points}}</div>
                <div style="color: rgb(88,157,248);">已使用零豆: {{detailData.spendpoints}}</div>
              </span>

            </span>
          </template>
        </el-table-column>
      </el-table>

    </el-row>
  </el-row>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      id: this.$route.query.userid || 0,
      detailData: {
        creditcardno: null,
        bankcity: null,
        bankname: null,
        photopath: null,
        idnum: null,
        idcardphotopath: null,
        idcardphoto_back: null,
        points: 0,
        frozenpoints: 0,
        spendpoints: 0,
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
        money_message: 4,
        point_message: 3,
        zfb_account: null,
        idnumverified: 0,
        idnum_verify_photo: null,
        workcard_photo: null,
      },
      table: [
        {
          key: 'creditcardno',
          label: '银行卡号',
        },
        {
          key: 'bankname',
          label: '银行信息',
        },
        {
          key: 'bankcity',
          label: '开户城市',
        },
        {
          key: 'photopath',
          label: '银行卡照片',
        },
        {
          key: 'zfb_account',
          label: '支付宝账号',
        },
        {
          key: 'idnumverified',
          label: '身份验证状态',
        },
        {
          key: 'idnum_verify_photo',
          label: '人脸验证照片',
        },
        {
          key: 'idnum',
          label: '身份证号',
        },
        {
          key: 'idcardphotopath',
          label: '身份证照片',
        },
        {
          key: 'idcardphoto_back',
          label: '身份证背面照片',
        },
        {
          key: 'money_message',
          label: '赏金信息',
        },
        {
          key: 'point_message',
          label: '零豆信息',
        },
      ],
      imgFields: ['idcardphotopath', 'photopath', 'idcardphoto_back', 'idnum_verify_photo'],
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.options,
  }),
  watch: {},
  created () {
    if (this.id) {
      this.setFormData(this.id)
    }
  },
  mounted () { },
  methods: {
    ...Vuex.mapActions([]),

    ifKey (scope, name) {
      return scope.row.key === name
    },
    setFormData (id) {
      request.page('getUserAccount', id).then(({data}) => {
        filter.setLoop(this.detailData, data)
      })
    },
    filterImgUrl (url) {
      let suffix = ''
      if (url.indexOf('?x-oss-process') === -1) {
        suffix = '?x-oss-process=image/resize,w_200/auto-orient,1'
      }
      return filter.ossHost(url, suffix)
    },
  },
}
</script>
<style lang="scss"
       scoped></style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersAccountDetail.vue